import dynamic from "next/dynamic";

export const DynamicGDPRBanner = dynamic(() => import(".").then(module => module.GDPRBanner));
